import type React from "react";
import {observer} from "mobx-react-lite";
import {DrawerMenuItem} from "../drawer/DrawerMenuItem.tsx";
import {List} from "@mui/material";
import Divider from "@mui/material/Divider";
import {DrawerMainLogo} from "../branding/DrawerMainLogo.tsx";
import {useStores} from "../../../stores";

export const MainMenu: React.FC = observer(() => {
    const {p, rootAppStore} = useStores();

    const CARDS = p.getVisibleCardsBySection();
    const sitSectionCards = CARDS['sit'];
    const chatSectionCards = CARDS['chat'];
    const data1SectionCards = CARDS['data_1'];
    const insights2SectionCards = CARDS['insights_2'];

    return (
        <>
            <DrawerMainLogo collapsed={!rootAppStore.isDrawerOpen}/>
            <List
                className="menuList"
                sx={{
                    "&.MuiList-root": {padding: 0},
                    ...(!rootAppStore.isDrawerOpen && {
                        "& .MuiListItemIcon-root": {
                            marginRight: '0px !important',
                        },
                    }),
                }}
            >
                <DrawerMenuItem card="__home__"/>

                {(sitSectionCards.length > 0) && <>
                    <Divider component="li"/>
                    {sitSectionCards.map(c => <DrawerMenuItem key={c} card={c}/>)}
                </>}

                {(chatSectionCards.length > 0) && <>
                    <Divider component="li"/>
                    {chatSectionCards.map(c => <DrawerMenuItem key={c} card={c}/>)}
                </>}

                {(data1SectionCards.length > 0) && <>
                    <Divider component="li"/>
                    {data1SectionCards.map(c => <DrawerMenuItem key={c} card={c}/>)}
                </>}

                {(insights2SectionCards.length > 0) && <>
                    <Divider component="li"/>
                    {insights2SectionCards.map(c => <DrawerMenuItem key={c} card={c}/>)}
                </>}
            </List>
        </>
    );
});
